/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { MasterViewModel } from './masterViewModel';

export interface ProcessViewModel { 
    id?: number;
    processType?: MasterViewModel;
    status?: MasterViewModel;
    createdBy?: string;
    createdUserName?: string;
    enqueueDate?: Date;
    startDate?: Date;
    endDate?: Date;
    projectId?: number;
    projectCode?: string;
    templateId?: number;
    templateCode?: string;
    error?: string;
    isFiltered?: boolean;
    fileName?: string;
}